import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DonationWayService } from '../../../../shared/API-Service/services/donation-way.service';
import Swal from 'sweetalert2';
import {BaseComponent } from '../../../../../app/shared/components/base/base.component'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../../environments/environment.prod';
@Component({
  selector: 'app-list-donation-way',
  templateUrl: './list-donation-way.component.html',
  styleUrls: ['./list-donation-way.component.css']
})
export class ListDonationWayComponent extends BaseComponent implements OnInit {
  DonationWay: any;
  closeResult: string;
  ShowPhoto: boolean;
  images: any[]=[];
  imagesView: string | ArrayBuffer;
  ProjectId: any;
  Image: File;
  ProjectName: any;
  CreatMediaProjectPicForm: any = new FormData();
  ProjectImages: any;
  constructor(public modalService: NgbModal,private _formBuilder: FormBuilder,private DonationWayService:DonationWayService,private _Router:Router) { super()}
  insertForm: FormGroup;
  ngOnInit(): void {
    this.getDonationWay();
    this.initForm();
  }
  initForm() {
    this.insertForm = this._formBuilder.group({
      title: ['', Validators.required],
      titleAr: ['', Validators.required],

    });
  }

  get fc() {
    return this.insertForm.controls;
  }

  pageChanged(event: any){
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
this.getDonationWay()

  }
  getDonationWay(){
   
    this.DonationWayService.GetDonationWayPaged(this.pager).subscribe((res) => {
      this.DonationWay = res.data.items
      this.totalCount=res.data.totalCount;
    
    },(err)=>{
    },() =>{
    });
  }
  update(id){
    this._Router.navigate(['/content/admin/update-donationway',id]);
    }

    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this.DonationWayService.DeleteDonationWay(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getDonationWay();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
          })
        }
      }) 
    }


}
